<script>
import BaseConfig from './_base-config.vue';

export default {
  name: 'AudioConferencingEdit',
  extends: BaseConfig,
};
</script>
